import React, { Component } from "react";
import { Link } from "react-router-dom";
class SideBar extends Component {
  render() {
    return (
      <div id="sidebar">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={0}
          data-smobile={0}
        />
        <div id="inner-sidebar" className="inner-content-wrap">
          <div className="widget widget_list">
            <div className="inner">
              <ul className="list-wrap">
                <li className="list-item">
                  <Link to="/about-us">
                    <span className="text">About K.Lizz Hardware</span>
                  </Link>
                </li>
                <li className="list-item">
                  <Link to="/products">
                    <span className="text">Our Products</span>
                  </Link>
                </li>
                <li className="list-item">
                  <Link to="/contact-01">
                    <span className="text">Visit Our Store</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="widget widget_instagram margin-top-51">
            <h2 className="widget-title margin-bottom-30">
              <span>OUR PRODUCTS</span>
            </h2>
            <div className="instagram-wrap data-effect clearfix col3 g10">
              <div className="instagram_badge_image has-effect-icon">
                <Link to="/products" className="data-effect-item">
                  <span className="item">
                    <img
                      src="assets/img/gallery/plywood-boards.jpeg"
                      alt="Plywood Boards"
                    />
                  </span>
                  <div className="overlay-effect bg-color-2" />
                  <div className="elm-link">
                    <span className="icon-3" />
                  </div>
                </Link>
              </div>
              <div className="instagram_badge_image has-effect-icon">
                <Link to="/products" className="data-effect-item">
                  <span className="item">
                    <img
                      src="assets/img/gallery/mdf-boards.jpeg"
                      alt="MDF Boards"
                    />
                  </span>
                  <div className="overlay-effect bg-color-2" />
                  <div className="elm-link">
                    <span className="icon-3" />
                  </div>
                </Link>
              </div>
              <div className="instagram_badge_image has-effect-icon">
                <Link to="/products" className="data-effect-item">
                  <span className="item">
                    <img src="assets/img/gallery/doors.jpeg" alt="Doors" />
                  </span>
                  <div className="overlay-effect bg-color-2" />
                  <div className="elm-link">
                    <span className="icon-3" />
                  </div>
                </Link>
              </div>
              <div className="instagram_badge_image has-effect-icon">
                <Link to="/products" className="data-effect-item">
                  <span className="item">
                    <img
                      src="assets/img/gallery/hardware-supplies.jpeg"
                      alt="Hardware Supplies"
                    />
                  </span>
                  <div className="overlay-effect bg-color-2" />
                  <div className="elm-link">
                    <span className="icon-3" />
                  </div>
                </Link>
              </div>
              <div className="instagram_badge_image has-effect-icon">
                <Link to="/products" className="data-effect-item">
                  <span className="item">
                    <img src="assets/img/gallery/paints.jpeg" alt="Paints" />
                  </span>
                  <div className="overlay-effect bg-color-2" />
                  <div className="elm-link">
                    <span className="icon-3" />
                  </div>
                </Link>
              </div>
              <div className="instagram_badge_image has-effect-icon">
                <Link to="/products" className="data-effect-item">
                  <span className="item">
                    <img src="assets/img/gallery/workshop.jpeg" alt="Workshop" />
                  </span>
                  <div className="overlay-effect bg-color-2" />
                  <div className="elm-link">
                    <span className="icon-3" />
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="widget widget_lastest_twitter margin-top-40">
            <h2 className="widget-title">
              <span>CONTACT INFO</span>
            </h2>
            <ul className="lastest-posts clearfix">
              <li className="clearfix">
                <div className="icon-wrap has-width w30">
                  <i className="fa fa-phone" />
                </div>
                <div className="text">
                  <p>
                    <strong>CEO:</strong>{" "}
                    <Link to="tel:0706494665">0706494665</Link>
                    <br />
                    <strong>Sales:</strong>{" "}
                    <Link to="tel:0729926703">0729926703</Link>
                  </p>
                </div>
              </li>
              <li className="clearfix">
                <div className="icon-wrap has-width w30">
                  <i className="fa fa-map-marker" />
                </div>
                <div className="text">
                  <p>
                    <strong>Location:</strong> Nairobi, Kenya
                    <br />
                    <Link to="/contact-01">Get Directions</Link>
                  </p>
                </div>
              </li>
              <li className="clearfix">
                <div className="icon-wrap has-width w30">
                  <i className="fa fa-clock-o" />
                </div>
                <div className="text">
                  <p>
                    <strong>Open Hours:</strong>
                    <br />
                    Mon-Sat: 7:00 AM - 6:30 PM
                    <br />
                    Sunday: Closed
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default SideBar;
